import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// Токены в localStorage
export function getTokens() {
  return {
    access: localStorage.getItem('access_token'),
    refresh: localStorage.getItem('refresh_token'),
  };
}

export function setTokens(access, refresh) {
  localStorage.setItem('access_token', access);
  localStorage.setItem('refresh_token', refresh);
}

export function clearTokens() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
}

export function getUser() {
  const raw = localStorage.getItem('user');
  return raw ? JSON.parse(raw) : null;
}

export function setUser(user) {
  localStorage.setItem('user', JSON.stringify(user));
}

// Request interceptor — добавляем access token
api.interceptors.request.use((config) => {
  const { access } = getTokens();
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

// Единый мьютекс на refresh — чтобы axios-интерсептор и socket-хук не шли в /auth/refresh
// параллельно и не ротировали refresh_token друг у друга.
let refreshPromise = null;

export function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;
  const { refresh } = getTokens();
  if (!refresh) return Promise.reject(new Error('NO_REFRESH_TOKEN'));
  refreshPromise = axios
    .post(`${API_URL}/api/auth/refresh`, { refresh_token: refresh })
    .then((res) => {
      const { access_token, refresh_token } = res.data;
      setTokens(access_token, refresh_token);
      return access_token;
    })
    .finally(() => { refreshPromise = null; });
  return refreshPromise;
}

// Response interceptor — refresh при 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (error.response.data?.error?.code === 'AUTH_EXPIRED') {
        originalRequest._retry = true;
        try {
          const access_token = await refreshAccessToken();
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return api(originalRequest);
        } catch (refreshErr) {
          clearTokens();
          window.location.href = '/login';
          return Promise.reject(refreshErr);
        }
      }

      // Другая 401 (невалидный токен)
      clearTokens();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
